import $, { css, get } from "jquery";
import "@fancyapps/fancybox";
import "magnific-popup";
import SignaturePad from "signature_pad";
import Swiper from "swiper/bundle";
// import "masonry-layout/dist/masonry.pkgd.min.js";
// import 'isotope-layout/dist/isotope.pkgd.min.js';

$(function ($) {
  // console.log("JS DONE");

  $(".tub-card-actions .add_to_cart_button").on("click", function () {
    jQuery(".wd-header-cart").trigger("click");
  });
  jQuery('.whb-main-header a[href^="#"], .hot-tub-section a[href^="#"]').on(
    "click",
    function (e) {
      e.preventDefault();

      var targetId = this.getAttribute("href");
      var target = jQuery(targetId);

      if (target.length) {
        var headerHeight = jQuery(".whb-main-header").outerHeight();
        var scrollPosition = target.offset().top - headerHeight;

        jQuery("html, body").animate(
          {
            scrollTop: scrollPosition,
          },
          800
        );
      } else {
        //If the block is not on the current page, go to the main page
        var homeUrl = window.location.origin; //Get the URL of the main page

        //Add block ID to URL
        window.location.href = homeUrl + "/" + targetId;
      }
    }
  );

  //Scroll to the block after going to the main page
  jQuery(document).on("ready", function () {
    var hash = window.location.hash; //Get the hash from the URL (eg #about)

    if (hash) {
      var target = jQuery(hash);

      if (target.length) {
        var headerHeight = jQuery(".whb-main-header").outerHeight(); //Fixed header height
        var scrollPosition = target.offset().top - headerHeight;

        jQuery("html, body").animate(
          {
            scrollTop: scrollPosition,
          },
          800
        );
      }
    }
  });

  $(".accordion-header").on("click", function () {
    const $item = $(this).parent();
    const $content = $item.find(".accordion-content");

    //Close all other elements
    $(".accordion-item")
      .not($item)
      .removeClass("active")
      .find(".accordion-content")
      .css("max-height", "0");

    //Switch the active class and set the max-height
    if ($item.hasClass("active")) {
      $item.removeClass("active");
      $content.css("max-height", "0");
    } else {
      $item.addClass("active");
      $content.css("max-height", $content.prop("scrollHeight") + "px");
    }
  });

  jQuery(document).on("updated_wc_div", function () {
    jQuery(".widget_shopping_cart").trigger("wc_update_cart_widget");
  });

  $(".selling-tub").on("click", function () {
    const productTitle = $(this).data("product-title");
    const productPrice = $(this).data("product-price");

    //Popup selection
    const popup = $('[data-popup="' + $(this).attr("data-popup-open") + '"]');
    //Select form in popup
    const form = popup.find(".wpcf7-form");

    //Update the fields
    form.find('input[name="product_title"]').val(productTitle);
    form.find('input[name="product_price"]').val(productPrice);
  });
  // Open
  $("[data-popup-open]").on("click", function (e) {
    //We get the value from the data-attributes of the button
    const productTitle = $(this).data("product-title");
    const productPrice = $(this).data("product-price");
    //Find hidden fields by ID and update their values
    $("#form-product-title").val(productTitle);
    $("#form-product-price").val("$" + productPrice);

    //Open the popup
    var targeted_popup_class = $(this).attr("data-popup-open");
    $('[data-popup="' + targeted_popup_class + '"]').fadeIn(350);

    //Block scrolling
    var scrollbarWidth =
      window.innerWidth - document.documentElement.clientWidth;
    $("html").css({
      "margin-right": scrollbarWidth + "px",
    });
    $("html").addClass("body-no-scroll-compensate");
    $("html").addClass("body-no-scroll");

    e.preventDefault();
  });
  $("[data-popup-open]").on("click", function (e) {
    console.log("Event handler is working");
  });
  console.log($("[data-popup-open]").attr("data-popup-open"));

  // // Open
  // $(document).on("click", "[data-popup-open]", function (e) {
  //   console.log("popup opened");

  //   var targeted_popup_class = $(this).attr("data-popup-open");
  //   $('[data-popup="' + targeted_popup_class + '"]').fadeIn(350);

  //   // Calculate the width of the scrollbar
  //   var scrollbarWidth =
  //     window.innerWidth - document.documentElement.clientWidth;
  //   $("html").css({
  //     "margin-right": scrollbarWidth + "px",
  //   });
  //   $("html").addClass("body-no-scroll-compensate");
  //   $("html").addClass("body-no-scroll");

  //   e.preventDefault();
  // });

  // Close
  $(document).on("click", "[data-popup-close]", function (e) {
    // $("[data-popup-close]").on("click", function (e) {
    var targeted_popup_class = $(this).attr("data-popup-close");
    $('[data-popup="' + targeted_popup_class + '"]').fadeOut(350);
    // Remove class and padding to restore scrollbar
    $("html").removeClass("body-no-scroll");
    $("html").removeClass("body-no-scroll-compensate");
    $("html").css({
      "margin-right": "",
    });
    e.preventDefault();
  });

  const fileUploadBox = $(".file-upload-box");
  const fileList = $(".file-list");
  const fileInput = $(".file-upload-input");

  // Handle drag and drop events
  fileUploadBox
    .on("dragover dragenter", function (e) {
      e.preventDefault();
      e.stopPropagation();
      $(this).addClass("drag-over");
    })
    .on("dragleave dragend drop", function (e) {
      e.preventDefault();
      e.stopPropagation();
      $(this).removeClass("drag-over");
    });

  // Handle file selection
  fileInput.on("change", function (e) {
    const files = e.target.files;
    handleFiles(files);
  });

  // Handle dropped files
  fileUploadBox.on("drop", function (e) {
    const files = e.originalEvent.dataTransfer.files;
    handleFiles(files);
  });

  function handleFiles(files) {
    Array.from(files).forEach((file) => {
      // Create progress bar element
      const progressBar = $('<div class="upload-progress"></div>');

      const fileItem = $(`
              <div class="file-item">
                  <i class="fas fa-file file-icon"></i>
                  <span class="file-name" title="${file.name}">${
        file.name
      }</span>
                  <i class="fas fa-times remove-file"></i>
                  ${progressBar.prop("outerHTML")}
              </div>
          `);

      fileList.append(fileItem);

      // Remove progress bar after animation
      setTimeout(() => {
        fileItem.find(".upload-progress").remove();
      }, 1000);

      // Handle file removal
      fileItem.find(".remove-file").on("click", function (e) {
        e.stopPropagation();
        fileItem.fadeOut(300, function () {
          $(this).remove();
        });
      });

      // Get appropriate FontAwesome icon based on file type
      const fileIcon = fileItem.find(".file-icon");
      const fileExtension = file.name.split(".").pop().toLowerCase();

      const iconMap = {
        pdf: "fa-file-pdf",
        doc: "fa-file-word",
        docx: "fa-file-word",
        xls: "fa-file-excel",
        xlsx: "fa-file-excel",
        ppt: "fa-file-powerpoint",
        pptx: "fa-file-powerpoint",
        jpg: "fa-file-image",
        jpeg: "fa-file-image",
        png: "fa-file-image",
        gif: "fa-file-image",
        zip: "fa-file-archive",
        rar: "fa-file-archive",
        txt: "fa-file-alt",
      };

      if (iconMap[fileExtension]) {
        fileIcon.removeClass("fa-file").addClass(iconMap[fileExtension]);
      }
    });
  }

  const simpleCarousel = new Swiper(".testimonial-carousel", {
    slidesPerView: 4,
    spaceBetween: 60,
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    autoplay: {
      delay: 6000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: ".testimonial-swiper-button-next",
      prevEl: ".testimonial-swiper-button-prev",
    },
    breakpoints: {
      1025: {
        slidesPerView: 3,
        spaceBetween: 60,
      },
      993: {
        slidesPerView: 3,
        spaceBetween: 24,
      },
      600: {
        slidesPerView: 2,
        spaceBetween: 24,
      },
      320: {
        slidesPerView: 1,
      },
    },
  });
  function setEqualHeight() {
    let maxHeight = 0;

    //Find the maximum height of all slides
    $(".testimonial-carousel .swiper-slide").each(function () {
      const thisHeight = $(this).outerHeight();
      if (thisHeight > maxHeight) {
        maxHeight = thisHeight;
      }
    });

    //Set the same height for all slides
    $(".testimonial-carousel .swiper-slide").css("height", maxHeight + "px");
  }

  //We execute the function when loading and resizing
  setEqualHeight();
  $(window).on("resize", setEqualHeight);
});
